import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-1 w-100" }
const _hoisted_2 = { class: "card-toolbar flex-fill" }
const _hoisted_3 = { class: "navbar navbar-light border-rounded w-100 row justify-content-between" }
const _hoisted_4 = { class: "col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" New Jobs ")
const _hoisted_13 = { class: "badge badge-rounded-pill bg-success" }
const _hoisted_14 = { class: "row mx-10 mt-5 mb-5" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "card-body p-2 p-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewJobAddressModal = _resolveComponent("ViewJobAddressModal")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_MyShiftsDataTable = _resolveComponent("MyShiftsDataTable")!
  const _component_PendingShiftsDataTable = _resolveComponent("PendingShiftsDataTable")!
  const _component_PastShiftsDataTable = _resolveComponent("PastShiftsDataTable")!
  const _component_NewJobsDataTable = _resolveComponent("NewJobsDataTable")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_ViewJobAddressModal, {
      key: _ctx.mapModalKey,
      payload: _ctx.mapModalPayload
    }, null, 8, ["payload"])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn w-100", 
              _ctx.activeTab == 'my'
                ? 'btn-primary text-white'
                : 'btn-outline-secondary text-dark'
            ]),
              type: "button",
              disabled: _ctx.loading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeActiveTab('my')))
            }, " My Shifts ", 10, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn w-100", 
              _ctx.activeTab == 'pending'
                ? 'btn-primary text-white'
                : 'btn-outline-secondary text-dark'
            ]),
              type: "button",
              disabled: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActiveTab('pending')))
            }, " Pending Shifts ", 10, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn w-100", 
              _ctx.activeTab == 'past'
                ? 'btn-primary text-white'
                : 'btn-outline-secondary text-dark'
            ]),
              type: "button",
              disabled: _ctx.loading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeActiveTab('past')))
            }, " Past Shifts ", 10, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn w-100", 
              _ctx.activeTab == 'new'
                ? 'btn-primary text-white'
                : 'btn-outline-secondary text-dark'
            ]),
              type: "button",
              disabled: _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeActiveTab('new')))
            }, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.newJobs), 1)
            ], 10, _hoisted_11)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_SearchField, {
          placeholder: 
          'Search job names, PMs, companies, invoice refs and venues'
        ,
          onChangeSearch: _ctx.handleSearch
        }, null, 8, ["onChangeSearch"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.activeTab == 'my' && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_MyShiftsDataTable, {
            key: 0,
            shifts: _ctx.shifts,
            onOpenMapModal: _ctx.handleViewAddressModal
          }, null, 8, ["shifts", "onOpenMapModal"]))
        : _createCommentVNode("", true),
      (_ctx.activeTab == 'pending' && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_PendingShiftsDataTable, {
            key: 1,
            shifts: _ctx.shifts,
            onOpenMapModal: _ctx.handleViewAddressModal
          }, null, 8, ["shifts", "onOpenMapModal"]))
        : _createCommentVNode("", true),
      (_ctx.activeTab == 'past' && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_PastShiftsDataTable, {
            key: 2,
            shifts: _ctx.shifts,
            onOpenMapModal: _ctx.handleViewAddressModal
          }, null, 8, ["shifts", "onOpenMapModal"]))
        : _createCommentVNode("", true),
      (_ctx.activeTab == 'new' && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_NewJobsDataTable, {
            key: 3,
            shifts: _ctx.shifts
          }, null, 8, ["shifts"]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.shifts == '' && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 5,
            description: "No shifts found for the current user"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Pagination, {
        currentPage: _ctx.getPagination.currentPage,
        totalPages: _ctx.getPagination.lastPage,
        onChangeCurrentPage: _ctx.changeActivePage
      }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
    ])
  ], 64))
}